// extracted by mini-css-extract-plugin
export default {"layoutHeader":"CrudLayout_layoutHeader__cj4pG","topEndComponent":"CrudLayout_topEndComponent__7O4Sd","layoutHeader2":"CrudLayout_layoutHeader2__oJuXV"};